import classNames from 'classnames';
import PropTypes from 'prop-types';

import './CustomTable.css';

function CustomTable({
  handleSort,
  handleSelectAll,
  headerItems,
  selectedHeaderItem,
  sortDirection,
  tableBody,
  checkAll,
  isLoading,
}) {
  const onHeaderClicked = ({ sort: sortBy, disableSorting }) => {
    if (disableSorting) return;
    handleSort(sortBy);
  };

  return (
    <table className="custom-table">
      <thead>
        <tr className="header-row">
          {handleSelectAll && (
            <th className="check-select">
              <input
                type="checkbox"
                id="masterCheckSelect"
                checked={checkAll}
                className="master-check-select"
                onChange={() => handleSelectAll(!checkAll)}
              />
            </th>
          )}
          {headerItems.map((headerItem) => (
            <th
              key={headerItem.displayName}
              className={classNames({
                'element-label': true,
                'disable-hover': headerItem.disableSorting,
                selected: selectedHeaderItem === headerItem.sort,
                [`${sortDirection}`]: selectedHeaderItem === headerItem.sort,
              })}
            >
              <button type="button" onClick={() => onHeaderClicked({ ...headerItem })}>
                {headerItem.displayName}
              </button>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableBody && tableBody}
        {isLoading && (
          <tr key="loadingIndicator" className="body-row loader">
            <td colSpan="6">
              <div className="spinner">
                <span className="loadingText">Loading...</span>
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

CustomTable.defaultProps = {
  checkAll: false,
  handleSelectAll: null,
  isLoading: false,
};

CustomTable.propTypes = {
  checkAll: PropTypes.bool,
  handleSelectAll: PropTypes.func,
  handleSort: PropTypes.func.isRequired,
  headerItems: PropTypes.arrayOf(
    PropTypes.shape({
      sort: PropTypes.string,
      displayName: PropTypes.string.isRequired,
      disableSorting: PropTypes.bool,
    })
  ).isRequired,
  isLoading: PropTypes.bool,
  selectedHeaderItem: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  tableBody: PropTypes.node.isRequired,
};

export default CustomTable;
